import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";
import { TruncatedText } from "../../utils/textTruncation";
import PlanChip from "../PlanChip";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MyJobsView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [postedJobList, setPostedJobList] = useState([]);
  const [awardedJoblist, setAwardedJoblist] = useState([]);
  const [myquoteList, setMyquoteList] = useState([]);
  const [postJobErrormsg, setpostJobErrormsg] = useState("");
  const [awardedJobErrormsg, setawardedJobErrormsg] = useState("");
  const [myquoteErrormsg, setMyquoteErrormsg] = useState("");
  const [sharedJobErrormsg, setSharedJobErrormsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [openShareJob, setOpenSharejob] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  
  const [ongoingJobsLoading, setOngoingJobsLoading] = useState(false);
  const [completedJobsLoading, setCompletedJobsLoading] = useState(false);
  const [appliedJobsLoading, setAppliedJobsLoading] = useState(false);

  const [commonSearch, setCommonSearch] = useState("");
  
  const [allPostedJobs, setAllPostedJobs] = useState([]);
  const [allAwardedJobs, setAllAwardedJobs] = useState([]);
  const [allMyQuotes, setAllMyQuotes] = useState([]);

  const commonSearchDebounceRef = useRef(null);

  const applyCommonFilter = useCallback((jobsData, searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') {
      return jobsData; 
    }
    
    const searchLower = searchTerm.toLowerCase();
    return jobsData.filter(job => 
      job.job_title?.toLowerCase().includes(searchLower) ||
      job.job_description?.toLowerCase().includes(searchLower) ||
      job.skills?.toLowerCase().includes(searchLower) ||
      job.job_location?.toLowerCase().includes(searchLower) ||
      job.category_full_name?.toLowerCase().includes(searchLower) ||
      job.parent_category_name?.toLowerCase().includes(searchLower) ||
      job.category_details?.parent_category_name?.toLowerCase().includes(searchLower) ||
      job.category_details?.child_category_name?.toLowerCase().includes(searchLower) ||
      job.job_unique_id?.toLowerCase().includes(searchLower)
    );
  }, []);

  const debouncedCommonSearch = useCallback((searchTerm) => {
    if (commonSearchDebounceRef.current) {
      clearTimeout(commonSearchDebounceRef.current);
    }
    
    commonSearchDebounceRef.current = setTimeout(() => {
      const filteredPosted = applyCommonFilter(allPostedJobs, searchTerm);
      const filteredAwarded = applyCommonFilter(allAwardedJobs, searchTerm);
      const filteredQuotes = applyCommonFilter(allMyQuotes, searchTerm);
      
      setPostedJobList(filteredPosted);
      setAwardedJoblist(filteredAwarded);
      setMyquoteList(filteredQuotes);
    }, 500); 
  }, [allPostedJobs, allAwardedJobs, allMyQuotes, applyCommonFilter]);

  useEffect(() => {
    debouncedCommonSearch(commonSearch);
    
    return () => {
      if (commonSearchDebounceRef.current) {
        clearTimeout(commonSearchDebounceRef.current);
      }
    };
  }, [commonSearch, debouncedCommonSearch]);

  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    onGoingJob();
    getQuoteList();
    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };
  const onGoingJob = () => {
    setOngoingJobsLoading(true);

    const FormData = require("form-data");

    const form = new FormData();
    form.append("job_type", 1);

    commonService
      .CommonService("explore_my_jobs", form)
      .then(async (res) => {
        if (res.status == 200) {
          setPostedJobList(res.data);
          setAllPostedJobs(res.data); 
        } else {
          setpostJobErrormsg(res.message)
        }
      })
      .catch((err) => {
        setpostJobErrormsg("Something went wrong! please try again later!!")

      })
      .finally(() => {
        setOngoingJobsLoading(false);

        alljob();
      });
  };


  const openInNewTab = (url) => {
    window.open("http://www.google.com",'','postwindow');
  }


  const alljob = (filter) => {
    setCompletedJobsLoading(true);
    setAwardedJoblist([]);
    setawardedJobErrormsg("")

    const FormData = require("form-data");

    const form = new FormData();
    form.append("job_type", 2);
    if(filter !== undefined){
      form.append("filter", filter);
    }
    commonService
      .CommonService("explore_my_jobs", form)
      .then(async (res) => {
        if (res.status == 200) {
          setAwardedJoblist(res.data);
          setAllAwardedJobs(res.data); 
        } else {
          setawardedJobErrormsg(res.message)

        }
      })
      .catch((err) => {
        setawardedJobErrormsg("Something went wrong! please try again later!!")

      })
      .finally(() => {
        setCompletedJobsLoading(false);
      });
  };


  const getQuoteList = () => {
    setAppliedJobsLoading(true);

    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("my_quotes", form)
      .then(async (res) => {
        if (res.status == 200) {
          setMyquoteList(res.data);
          setAllMyQuotes(res.data); // Store original data
        } else {
          setMyquoteErrormsg(res.message)
        }
      })
      .catch((err) => {
        setMyquoteErrormsg("Something went wrong! please try again later!!")

      })
      .finally(() => {
        setAppliedJobsLoading(false);
      });
  };


  return (
    <section className="post submitted">
      <div className="container">
        <div className="banner paddimg-bottom">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="/">
                      <i className="bx bx-chevron-left" /> Back to all jobs
                    </a>
                  </li>
                </ul>
                <div className="header-container">
                  <h1 className="quotes-title header-title">My Jobs</h1>
                  
                  <div className="search-container">
                    <div className="search-input-wrapper">
                      <img 
                        src="assets/images/SearchIcon.svg" 
                        alt="Search" 
                        className="search-icon"
                      />
                      <input
                        type="text"
                        placeholder="Search jobs..."
                        value={commonSearch}
                        onChange={(e) => {
                          setCommonSearch(e.target.value);
                        }}
                        className="search-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="quotes">
          <div className="tabset">
            <input
              type="radio"
              name="tabset"
              id="tab1"
              aria-controls="myquotes"
              defaultChecked
            />
            <label htmlFor="tab1">Applied</label>
            <input
              type="radio"
              name="tabset"
              id="tab2"
              aria-controls="marzen"
            />
            <label htmlFor="tab2">Ongoing</label>
            <input
              type="radio"
              name="tabset"
              id="tab3"
              aria-controls="rauchbier"
            />
            <label htmlFor="tab3">Completed</label>
            <div className="tab-panels">
              <section id="myquotes" className="tab-panel">
                {appliedJobsLoading ? (
                  <div className="job-loading-spinner">
                    <div className="job-spinner"></div>
                  </div>
                ) : !myquoteList.length > 0 ? (
                  <div className="no-jobs-message">
                    <div className="no-jobs-icon">📋</div>
                    <h3>No Applied Jobs Found</h3>
                    <p>{myquoteErrormsg || "You haven't applied to any jobs yet."}</p>
                  </div>
                ) : (
                  <LoadingOverlay>
                  {myquoteList.map((item) => (
                    <div key={item.quote_id} className="post-list">
                      <Link className="job-link" style={{width: "100%"}} to={{ pathname: `/myquote/${item.quote_id}/`, state: { item } }}>
                        <div className="plan-meta-row">
                          <div className="plan-chip-container">
                            {item.job_plan && <PlanChip jobPlan={item.job_plan} />}
                          </div>
                          <div className="job-meta">
                            <span className="job-id">Job ID: {item.job_unique_id?.replace('Job# ', '') || item.id}</span>
                            <span className="job-location">• <TruncatedText text={item.job_location} maxLength={50} /></span>
                          </div>
                        </div>

                        <div className="category-skills-row">
                          <div className="job-category">
                            {item.category_details?.parent_category_name && item.category_details?.child_category_name 
                              ? `${item.category_details.parent_category_name} > ${item.category_details.child_category_name}`
                              : item.parent_category_name && item.category_full_name 
                              ? `${item.parent_category_name} > ${item.category_full_name}`
                              : item.category_full_name || item.category || 'General'}
                          </div>
                          {item.skills && (
                            <div className="job-title-skills">
                              {item.skills.split(',').map((skill, index) => (
                                <span key={index} className="skill-tag">
                                  {skill.trim()}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>

                        <h1 className="job-title">
                          <TruncatedText 
                            text={item.job_title} 
                            maxLength={50} 
                            className="job-title-text" 
                          />
                        </h1>

                        {/* {item.is_fws_verified ? (
                          <li className="verified">
                            <img
                              src="assets/images/verified.png"
                              className="verified"
                            />{" "}-
                            Job verified by GigFWS
                          </li>
                        ) : null} */}

                        <div className="payment-info">
                          <div className="payment-amount">
                            ₹{item.amount}
                          </div>
                          <div className="payment-details">
                            {item.job_bid_type} | {item.timestamp}
                          </div>
                        </div>


                        <div className="job-footer">
                          <div className="target-date">
                            Target Close Date: {item.target_closed_date}
                          </div>
                          <div className="quotes-count">
                            {item.is_awarded === null ? `${item.total_quotes_received || 0} Quotes received` : 'Job is awarded to someone'}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                  <Loader loading={loading} />
                </LoadingOverlay>
                )}
              </section>
              <section id="marzen" className="tab-panel">
                {ongoingJobsLoading ? (
                  <div className="job-loading-spinner">
                    <div className="job-spinner"></div>
                  </div>
                ) : !postedJobList.length > 0 ? (
                  <div className="no-jobs-message">
                    <div className="no-jobs-icon">📋</div>
                    <h3>No Ongoing Jobs Found</h3>
                    <p>{postJobErrormsg || "You don't have any ongoing jobs at the moment."}</p>
                  </div>
                ) : (
                  <LoadingOverlay>
                  {postedJobList.map((item) => (
                    <div key={item.id} className="post-list">
                      <Link className="job-link" style={{width: "100%"}} to={{ pathname: `/myjobsdetail/${item.id}/`, state: { item } }}>
                        <div className="plan-meta-row">
                          <div className="plan-chip-container">
                            {item.job_plan && <PlanChip jobPlan={item.job_plan} />}
                          </div>
                          <div className="job-meta">
                            <span className="job-id">Job ID: {item.job_unique_id?.replace('Job# ', '') || item.id}</span>
                            <span className="job-location">• <TruncatedText text={item.job_location} maxLength={50} /></span>
                          </div>
                        </div>

                        <div className="category-skills-row">
                          <div className="job-category">
                            {item.category_details?.parent_category_name && item.category_details?.child_category_name 
                              ? `${item.category_details.parent_category_name} > ${item.category_details.child_category_name}`
                              : item.parent_category_name && item.category_full_name 
                              ? `${item.parent_category_name} > ${item.category_full_name}`
                              : item.category_full_name || item.category || 'General'}
                          </div>
                          {item.skills && (
                            <div className="job-title-skills">
                              {item.skills.split(',').map((skill, index) => (
                                <span key={index} className="skill-tag">
                                  {skill.trim()}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>

                        <h1 className="job-title">
                          <TruncatedText 
                            text={item.job_title} 
                            maxLength={50} 
                            className="job-title-text" 
                          />
                        </h1>

                       

                        <div className="payment-info">
                          <div className="payment-amount">
                            ₹{item.amount}
                          </div>
                          <div className="payment-details">
                            {item.bid_payment_term} | {item.timestamp}
                          </div>
                        </div>


                        <div className="job-footer">
                          <div className="target-date">
                            Target Close Date: {item.target_closed_date}
                          </div>
                         
                        </div>
                      </Link>
                    </div>
                  ))}
                  <Loader loading={loading} />
                </LoadingOverlay>
                )}
              </section>
              <section id="rauchbier" className="tab-panel">
            
                {completedJobsLoading ? (
                  <div className="job-loading-spinner">
                    <div className="job-spinner"></div>
                  </div>
                ) : !awardedJoblist.length > 0 ? (
                  <div className="no-jobs-message">
                    <div className="no-jobs-icon">📋</div>
                    <h3>No Completed Jobs Found</h3>
                    <p>{awardedJobErrormsg || "You don't have any completed jobs yet."}</p>
                  </div>
                ) : (
                  <LoadingOverlay>
                  {awardedJoblist.map((item) => (
                    <div key={item.id} className="post-list">
                      <Link className="job-link" style={{width: "100%"}} to={{ pathname: `/myjobsdetail/${item.id}/`, state: { item } }}>
                        <div className="plan-meta-row">
                          <div className="plan-chip-container">
                            {item.job_plan && <PlanChip jobPlan={item.job_plan} />}
                          </div>
                          <div className="job-meta">
                            <span className="job-id">Job ID: {item.job_unique_id?.replace('Job# ', '') || item.id}</span>
                            <span className="job-location">• <TruncatedText text={item.job_location} maxLength={50} /></span>
                          </div>
                        </div>

                        <div className="category-skills-row">
                          <div className="job-category">
                            {item.category_details?.parent_category_name && item.category_details?.child_category_name 
                              ? `${item.category_details.parent_category_name} > ${item.category_details.child_category_name}`
                              : item.parent_category_name && item.category_full_name 
                              ? `${item.parent_category_name} > ${item.category_full_name}`
                              : item.category_full_name || item.category || 'General'}
                          </div>
                          {item.skills && (
                            <div className="job-title-skills">
                              {item.skills.split(',').map((skill, index) => (
                                <span key={index} className="skill-tag">
                                  {skill.trim()}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>

                        <h1 className="job-title">
                          <TruncatedText 
                            text={item.job_title} 
                            maxLength={50} 
                            className="job-title-text" 
                          />
                        </h1>

                       

                        <div className="payment-info">
                          <div className="payment-amount">
                            ₹{item.amount}
                          </div>
                          <div className="payment-details">
                            {item.bid_payment_term} | {item.timestamp}
                          </div>
                        </div>


                        <div className="job-footer">
                          <div className="target-date">
                            Target Close Date: {item.target_closed_date}
                          </div>
                          
                        </div>
                      </Link>
                    </div>
                  ))}
                  <Loader loading={loading} />
                </LoadingOverlay>
                )}
              </section>
            </div>
          </div>
        </div>
      </div>
     
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyJobsView);
